import CustomAppBar from 'Components/Layout/CustomAppBar'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import StyledToolbar from 'Components/Layout/StyledToolbar'
import MenuBarAppName from 'Components/MenuBarAppName'
import NavigationMenu from 'Components/NavigationMenu'
import PTABanner from 'Components/PTABanner'
import UserMenu from 'Components/UserMenu/UserMenu'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import {
  isGlobalSection,
  useIsPtaBannerVisible
} from 'Services/common/Features/Authority/Context/utils'
import { isSuperuserOrSPMUser } from 'Services/common/Features/User/userSlice'
import { useTypedSelector } from 'Store'
import { TOOLBAR_HEIGHT } from 'Util/constants'
import { Box, ListItemIcon, MenuItem, MenuList, styled } from '@mui/material'
import ListItemText from '@mui/material/ListItemText'
import type { FC } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: 0,
  '&:has(> a.active)': {
    backgroundColor: 'rgba(255,255,255,.08)',
    borderBottom: `2px solid ${theme.palette.tertiary.main}`
  },
  '.MuiListItemIcon-root': {
    color: 'white',
    minWidth: 30
  }
}))

const StyledNavLink = styled(NavLink)(() => ({
  textDecoration: 'none',
  display: 'inline-flex',
  height: '100%',
  alignItems: 'center',
  padding: '0 16px',
  '.MuiTypography-root': {
    color: 'white',
    fontSize: 15
  }
}))

const MenuBar: FC<{ menuBarNavLinks: NavLinkItem[] }> = ({ menuBarNavLinks }) => {
  const { user } = useTypedSelector(state => state.user)
  const location = useLocation()
  const { selectedAuthorityCode, getCodespaceNameByCode } = useAuthorityContext()
  const isPtaBannerVisible = useIsPtaBannerVisible(user, location)

  return (
    <CustomAppBar>
      <StyledToolbar>
        <MenuBarAppName />
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {isSuperuserOrSPMUser(user) && (
            <MenuList sx={{ p: 0 }}>
              {menuBarNavLinks.map((item, i) => (
                <StyledMenuItem
                  key={`${item.title}-${i}`}
                  sx={{ display: 'inline-flex', height: TOOLBAR_HEIGHT }}
                >
                  <StyledNavLink to={item.link} className={'menu-link'}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} />
                  </StyledNavLink>
                </StyledMenuItem>
              ))}
            </MenuList>
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              gap: 2
            }}
          >
            <NavigationMenu />
            <UserMenu />
          </Box>
        </Box>
      </StyledToolbar>
      {isPtaBannerVisible && (
        <PTABanner
          selectedPta={getCodespaceNameByCode(selectedAuthorityCode ?? '')}
          isGlobalSection={isGlobalSection(location)}
        />
      )}
    </CustomAppBar>
  )
}

export default MenuBar
